import { render, staticRenderFns } from "./PosterPreview.vue?vue&type=template&id=0e4a8238&"
import script from "./PosterPreview.vue?vue&type=script&lang=js&"
export * from "./PosterPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports